module.exports = "pegasus_template/assets/four-column-images-preview.png";